import Avatar from "@mui/material/Avatar";
import Drawer from "@mui/material/Drawer";
import { useEffect, useState } from "react";
import { ReactComponent as NotificationInActiveSvg } from "../../assets/Icons/profile/Notification _ Profile _ normal state.svg";
import logoDark from "../../assets/LOGO.png";
import logo from "../../assets/White logo.svg";
import { Profile } from "../Profile/Profile";
import "./Navbar.css";
import CloseIcon from "@mui/icons-material/Close";
import ScratchCard from "react-scratchcard-v2";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Button, Grid, useMediaQuery } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import DefaultMaleProfilePic from "../../assets/Icons/profile/Profile icon _ male.png";
import {
  useGetUserNotificationsCountQuery,
  useGetUserNotificationsQuery,
} from "../../redux-toolkit/features/notifications/notificationsApiSlice";
import { useGetPointsQuery } from "../../redux-toolkit/features/points/pointsApiSlice";
import { apiSlice } from "../../redux-toolkit/api/apiSlice";
import { useGetInitialAppliedThemeQuery } from "../../redux-toolkit/features/theme/themeApiSlice";
import {
  selectedTheme,
  setStep,
  setTourActive,
} from "../../redux-toolkit/features/theme/themeSlice";
import setupSocket from "../../utils/socket";
import { isPromotionInviteResponsePath } from "../../utils/mobileAppGate";
import NotificationBody from "../Notifications/NotificationBody";
import { ReactComponent as RewardsSvg } from "../../assets/Navbar icons/rewards_outlined.svg";
import { ReactComponent as RewardsSvgH } from "../../assets/Navbar icons/rewards_filled.svg";
import { ReactComponent as TimeTrailsSvg } from "../../assets/Navbar icons/time_trails_outlined.svg";
import { ReactComponent as TimeTrailsSvgH } from "../../assets/Navbar icons/time_trails_filled.svg";
import { ReactComponent as PointsSvg } from "../../assets/Navbar icons/my activity.svg";
import { ReactComponent as PointsSvgH } from "../../assets/Navbar icons/my activity_filled.svg";
import { ReactComponent as QoinsSvgH } from "../../assets/Navbar icons/Qoins_logo.svg";
import img from "../../assets/scratch_card.png";

import { Modal } from "@mui/material";
import { Box } from "@mui/system";
import Confetti from "react-confetti";
import { useLocation } from "react-router-dom";
import { CompanySwitcher } from "../Admin/CompanySwitcher/CompanySwitcher";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  right: "50%",
  overflow: "hidden",
  transform: "translate(-50%, -50%)",
  width: "350px",
  bgcolor: "background.paper",
  borderRadius: "20px",
  boxShadow: 24,
  p: "0",
};

const normalizeEntityId = (value) => {
  if (value == null) return "";
  if (typeof value === "object" && value._id != null) {
    return String(value._id);
  }
  return String(value);
};

const isCurrentUserOwner = (owner, userId) => {
  if (!userId || owner == null) return false;
  return normalizeEntityId(owner) === normalizeEntityId(userId);
};

const payloadBelongsToUser = (payload, userId) => {
  if (!userId) return false;
  if (Array.isArray(payload)) {
    return payload.some((item) => isCurrentUserOwner(item?.owner, userId));
  }
  return isCurrentUserOwner(payload?.owner, userId);
};

export const Navbar = ({
  isBook,
  isAdmin,
  bookMode,
  isPreview,
  isTimeTrail = false,
  timeTrailMode,
}) => {
  const socket = setupSocket();
  const [congratsNotification, setCongratsNotification] = useState(null);
  const [showConfetti, setShowConfetti] = useState(false);
  const [notificationType, setNotificationType] = useState("all");
  const { pathname } = useLocation();
  const isMobileViewport = useMediaQuery("(max-width:768px)");
  const inviteOnlyNav =
    isMobileViewport && isPromotionInviteResponsePath(pathname);
  const { data: notifications, refetch: refetchNotifications } =
    useGetUserNotificationsQuery(notificationType, {
      refetchOnMountOrArgChange: true,
    });
  const { data: unseenNotificationCount, refetch: refetchUnseenNotifications } =
    useGetUserNotificationsCountQuery(null, {
      refetchOnMountOrArgChange: true,
    });
  const dispatch = useDispatch();
  const [state, setState] = useState(false);
  const [notificationToggle, setNotificationToggle] = useState(false);
  const theme = useSelector(selectedTheme);

  const { data } = useGetInitialAppliedThemeQuery({
    refetchOnMountOrArgChange: true,
  });

  // Resolved theme: API when loaded, else Redux. Light theme → dark logo, dark theme → light logo.
  const resolvedMode =
    data?.data?.mode ??
    (theme === "dark" || theme === false ? "dark" : "light");
  // When rendering theme previews, force the logo mode to match the selected preview.
  // `bookMode` is misnamed historically, but in preview it contains the desired mode ("dark"/"light").
  const normalizedBookMode =
    typeof bookMode === "string" ? bookMode.toLowerCase() : null;
  const previewForcedMode =
    isPreview &&
    (normalizedBookMode === "dark" || normalizedBookMode === "light")
      ? normalizedBookMode
      : null;
  const logoMode = previewForcedMode ?? resolvedMode;
  // On TimeTrials only: use page theme so Navbar matches. Books page uses same navbar as Rewards (global theme).
  const effectiveMode = isTimeTrail
    ? (timeTrailMode ?? resolvedMode)
    : resolvedMode;
  // For books pages, the navbar background is rendered as white in CSS,
  // so keep divider/chevron colors dark regardless of the theme mode.
  // Note: Some book pages use dynamic Quest routes without "/books" in the URL,
  // so also detect the course-detail pattern: ".../task/:taskId/course/:courseId".
  const isBookLikeRoute =
    pathname.includes("/books") ||
    (pathname.includes("/task/") && pathname.includes("/course/")) ||
    pathname.includes("/quest/books/");

  const navbarColorMode = isBookLikeRoute
    ? "light"
    : isTimeTrail
      ? effectiveMode
      : resolvedMode;
  // In preview mode, force the profile chevron color to follow preview theme.
  const profileArrowMode = isPreview && previewForcedMode
    ? previewForcedMode
    : navbarColorMode;
  const { data: pointsData } = useGetPointsQuery(undefined, {
    refetchOnReconnect: true,
  });

  const [notificationCount, setNotificationCount] = useState(0);
  const user = useSelector((state) => state.auth.user);

  const safeRefetch = (refetchFn) => {
    if (typeof refetchFn !== "function") return;
    try {
      Promise.resolve(refetchFn()).catch(() => {});
    } catch (_error) {
      // query may be uninitialized during fast route transitions
    }
  };

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    if (!isPreview) {
      setState(!state);
      setNotificationToggle(false);
    }
    if (!isPreview && !open) {
      dispatch(setTourActive(false));
      dispatch(setStep([]));
    }
  };

  const handleNotificationDataRefetch = () => {
    safeRefetch(refetchNotifications);
    safeRefetch(refetchUnseenNotifications);
  };

  const handleNotificationDrawer = () => {
    if (!isPreview) {
      setNotificationToggle(!notificationToggle);
      setState(false);
    }
    toggleDrawer("top", false);
    handleNotificationDataRefetch();
  };

  const handleNotificationDrawerClose = () => {
    setNotificationToggle(false);
  };

  useEffect(() => {
    setNotificationCount(unseenNotificationCount?.data || 0);
  }, [unseenNotificationCount]);

  useEffect(() => {
    const invalidatePointsCaches = () => {
      dispatch(apiSlice.util.invalidateTags(["Points", "UserActivity"]));
    };

    socket?.on("taskApproval", (payload) => {
      // Server emits this only to the receiver's sockets; always refresh points.
      invalidatePointsCaches();
      if (payloadBelongsToUser(payload, user?._id)) {
        setNotificationCount((prev) => prev + (payload?.length || 1));
      }
    });

    socket?.on("taskRejection", (payload) => {
      if (payloadBelongsToUser(payload, user?._id)) {
        setNotificationCount((prev) => prev + 1);
      }
    });
    socket?.on("permissionChange", (payload) => {
      if (payloadBelongsToUser(payload, user?._id)) {
        setNotificationCount((prev) => prev + 1);
      }
    });
    socket?.on("bookUnlocked", (payload) => {
      if (payloadBelongsToUser(payload, user?._id)) {
        setNotificationCount((prev) => prev + 1);
      }
    });
    socket?.on("companyBookCreate", (payload) => {
      setNotificationCount((prev) => prev + 1);
    });
    socket?.on("companyTaskSubmission", (payload) => {
      setNotificationCount((prev) => prev + 1);
    });

    socket?.on("rewardApproval", (payload) => {
      setNotificationCount((prev) => prev + 1);
      invalidatePointsCaches();
    });

    socket?.on("rewardDispatched", (payload) => {
      setNotificationCount((prev) => prev + 1);
      invalidatePointsCaches();
    });

    socket?.on("badgeCongratulate", (payload) => {
      if (payloadBelongsToUser(payload, user?._id)) {
        setNotificationCount((prev) => prev + (payload?.length || 1));
      }
    });

    const bumpIfOwned = (payload) => {
      if (payloadBelongsToUser(payload, user?._id)) {
        setNotificationCount((prev) => prev + 1);
      }
    };
    socket?.on("promotionInvite", bumpIfOwned);
    socket?.on("promotionInviteReminder", bumpIfOwned);
    socket?.on("promotionInviteAccepted", bumpIfOwned);
    socket?.on("promotionInviteRejected", bumpIfOwned);
    socket?.on("promotionInviteCancelled", bumpIfOwned);

    return () => {
      socket?.off("taskApproval");
      socket?.off("taskRejection");
      socket?.off("bookUnlocked");
      socket?.off("permissionChange");
      socket?.off("companyBookCreate");
      socket?.off("companyTaskSubmission");
      socket?.off("rewardApproval");
      socket?.off("badgeCongratulate");
      socket?.off("rewardDispatched");
      socket?.off("promotionInvite");
      socket?.off("promotionInviteReminder");
      socket?.off("promotionInviteAccepted");
      socket?.off("promotionInviteRejected");
      socket?.off("promotionInviteCancelled");
    };
  }, [socket, user?._id, dispatch]);

  return (
    <>
      {showConfetti ? (
        <Confetti
          width={550}
          gravity={0.4}
          height={window?.innerHeight}
          numberOfPieces={600}
          recycle={false}
          style={{
            margin: "0 auto",
            zIndex: 10000,
            position: "fixed",
            top: 0,
          }}
        />
      ) : null}
      <Modal
        open={!!congratsNotification}
        onClose={() => {
          setShowConfetti(false);
          setCongratsNotification(null);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div
            style={{
              position: "absolute",
              right: "16px",
              top: "16px",
              zIndex: 100,
            }}
          >
            <CloseIcon
              onClick={() => {
                setShowConfetti(false);
                setCongratsNotification(null);
              }}
              sx={{
                fontSize: "20px",
                cursor: "pointer",
                color: "var(--grey400)",
                "&:hover": {
                  color: "var(--error)",
                },
              }}
            />
          </div>
          <ScratchCard
            width={350}
            height={440}
            image={img}
            finishPercent={30}
            onComplete={() => setShowConfetti(true)}
          >
            <div
              style={{
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                padding: "20px",
              }}
            >
              <h1
                style={{
                  fontFamily: "Alex Brush, cursive",
                  fontSize: "50px",
                  color: "#ffbe18",
                  textAlign: "center",
                  marginTop: "-30px",
                }}
              >
                Congratulations!
              </h1>
              <p style={{ textAlign: "center", paddingTop: "20px" }}>
                <span style={{ color: "#3661cf", fontWeight: "bold" }}>
                  {congratsNotification?.payload?.content?.split("is")[0]}
                </span>{" "}
                is
                {congratsNotification?.payload?.content?.split("is")[1]}
              </p>{" "}
            </div>
          </ScratchCard>
        </Box>
      </Modal>

      <div
        className={`nav${inviteOnlyNav ? " nav--invite-only" : ""}`}
        data-theme={isTimeTrail ? effectiveMode : undefined}
      >
        <Grid
          container
          sx={{ width: "100%", height: "100%", padding: "0px 30px " }}
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid
            item
            sx={{ width: "15vw", display: "flex", justifyContent: "center" }}
          >
            {(() => {
              const logoSrc = isPreview
                ? logoMode === "dark"
                  ? logo
                  : logoDark
                : isBook
                  ? logoDark
                  : isTimeTrail
                    ? effectiveMode === "dark"
                      ? logo
                      : logoDark
                    : resolvedMode === "dark"
                      ? logo
                      : logoDark;
              const logoImg = (
                <img src={logoSrc} width="160px" alt="The Quest" />
              );
              // Invite-only mobile: Quest is gated elsewhere — keep the mark, don't navigate away.
              if (inviteOnlyNav) return logoImg;
              return (
                <Link to={user?.role === "IT" ? "/super-admin" : "/quest"}>
                  {logoImg}
                </Link>
              );
            })()}
          </Grid>

          <Grid item>
            <Grid
              container
              spacing={{
                md: 1,
                xl: 2,
              }}
            ></Grid>
          </Grid>

          <Grid item>
            <div className="nav__right">
              {!inviteOnlyNav && (
              <div className="nav__icons">
                <div id="step22" className="nav__iconsbg">
                  {!pathname.includes("super-admin") &&
                    !pathname.includes("/admin") && (
                      <Link to={"/quest/time-trails"}>
                        <div className="nav__Icons1">
                          <TimeTrailsSvgH style={{ width: 35, height: 35 }} />

                          <div className="nav__IconsH1">
                            <TimeTrailsSvg style={{ width: 35, height: 35 }} />
                          </div>
                        </div>
                      </Link>
                    )}
                </div>
                <div
                  id="step23"
                  // onMouseOut={() => setIsWallet(false)}
                  // onMouseOver={() => setIsWallet(true)}
                  className="nav__iconsbg"
                >
                  {!pathname.includes("super-admin") &&
                    !pathname.includes("/admin") && (
                      <Link to={"/quest/rewards"}>
                        <div className="nav__Icons1">
                          <RewardsSvgH style={{ width: 35, height: 35 }} />

                          <div className="nav__IconsH1">
                            <RewardsSvg style={{ width: 35, height: 35 }} />
                          </div>
                        </div>
                      </Link>
                    )}

                  {true && (
                    <div className="nav__icontext">
                      <div className="comment-box">
                        <div
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                          }}
                        >
                          <QoinsSvgH style={{ width: "40px" }} />:
                          <span style={{ color: "var(--pblue)" }}>
                            &nbsp;{pointsData && pointsData?.data?.walletPoints}
                          </span>
                        </div>

                        <Link to={"/quest/rewards"}>
                          <Button variant="contained">Rewards</Button>
                        </Link>
                      </div>
                    </div>
                  )}
                </div>
                <div
                  id="step24"
                  // onMouseOver={() => setIsPoint(true)}
                  // onMouseOut={() => setIsPoint(false)}
                  className="nav__iconsbg"
                >
                  {!pathname.includes("super-admin") &&
                    !pathname.includes("admin") && (
                      <Link to={"/quest/my-activity"}>
                        <div className="nav__Icons1">
                          <PointsSvgH style={{ width: 35, height: 35 }} />

                          <div className="nav__IconsH1">
                            <PointsSvg style={{ width: 35, height: 35 }} />
                          </div>
                        </div>
                      </Link>
                    )}
                  {true && (
                    <div className="nav__icontext">
                      <div className="comment-box">
                        <div
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                          }}
                        >
                          Total Points:
                          <span style={{ color: "var(--pblue)" }}>
                            &nbsp;
                            {pointsData && pointsData?.data?.earnedPoints}{" "}
                          </span>
                        </div>
                        <Link to={"/quest/my-activity"}>
                          <Button variant="contained">My Activity</Button>
                        </Link>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              )}
              {/* Company Switcher for Admin users */}
              {isAdmin && !inviteOnlyNav && <CompanySwitcher />}
              {!inviteOnlyNav &&
                !pathname.includes("super-admin") &&
                !pathname.includes("admin") && (
                  <div
                    className="nav__separator-line"
                    style={{
                      height: "30px",
                      width: "1px",
                      backgroundColor:
                        navbarColorMode === "dark" ? "#f2f2f2" : "#747474",
                    }}
                  ></div>
                )}
              <div className="nav__profile">
                {!inviteOnlyNav && (
                <div className="step25">
                  <div
                    className="nav__notifyiconsbg"
                    onClick={handleNotificationDrawer}
                  >
                    {notificationCount > 0 ? (
                      <span className="nav__notif_count">
                        {notificationCount > 9 ? "9+" : notificationCount}
                      </span>
                    ) : null}
                    <NotificationInActiveSvg
                      style={{ width: 20, height: 20 }}
                    />
                  </div>
                </div>
                )}

                <div>
                  <div>
                    <div
                      className="nav__profileControls"
                      onClick={toggleDrawer("top", true)}
                    >
                      <div className="nav__profilepic">
                        <Avatar
                          alt="Profile"
                          sx={{ width: "35px", height: "35px" }}
                          src={user?.avatar || DefaultMaleProfilePic}
                          imgProps={{ referrerPolicy: "no-referrer" }}
                        />
                      </div>
                      {!inviteOnlyNav && (
                      <div className="avatar__arrow">
                        <ArrowBackIosIcon
                          sx={{
                            color:
                              profileArrowMode === "dark"
                                ? "#f2f2f2"
                                : "#747474",
                            fontSize: "20px",
                          }}
                        />
                      </div>
                      )}
                    </div>
                    <Drawer
                      anchor={"top"}
                      sx={{
                        backgroundColor: "transparent",
                      }}
                      BackdropProps={{ invisible: true }}
                      PaperProps={{
                        sx: {
                          margin: "70px 33px 0px 0px",
                          marginLeft: "auto",
                          padding: "0px 10px",
                          width: "280px",
                          // zIndex: '9999 !important',
                          // Keep profile dropdown consistently light across all pages/routes.
                          backgroundColor: "#f5f5f5 !important",
                          border: "1px solid var(--grey200)",
                          borderRadius: "0 0 10px 10px",
                          borderTop: "0px",
                          boxShadow: "0 16px 32px rgba(0,0,0,0.07)",
                        },
                      }}
                      open={state}
                      onClose={toggleDrawer("top", false)}
                    >
                      <Profile
                        toggleDrawer={toggleDrawer}
                        theme={isTimeTrail ? effectiveMode : theme}
                      />
                    </Drawer>
                  </div>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>

        <Drawer
          anchor={"top"}
          sx={{
            backgroundColor: "transparent",
          }}
          BackdropProps={{ invisible: true }}
          PaperProps={{
            sx: {
              margin: "70px 120px 0px 0px",
              marginLeft: "auto",
              padding: "20px 20px 10px 20px",
              width: "450px",
              backgroundColor: "var(--slightgrey)",
              border: "1px solid var(--grey200)",
              borderRadius: "0 0 10px 10px",
              borderTop: "0px",
              boxShadow: "0 16px 32px rgba(0,0,0,0.07)",
            },
          }}
          open={notificationToggle}
          onClose={(_, reason) =>
            reason === "backdropClick" && handleNotificationDrawerClose()
          }
        >
          {notifications ? (
            <NotificationBody
              setNotificationType={setNotificationType}
              handleClose={handleNotificationDrawerClose}
              notifications={notifications?.data || []}
              refetchData={handleNotificationDataRefetch}
              onClick={(notification) => {
                if (
                  notification?.payload?.metadata?.action === "CONGRATULATIONS"
                ) {
                  setTimeout(() => {
                    setCongratsNotification(notification);
                  }, 1000);
                }
              }}
            />
          ) : null}
        </Drawer>
      </div>
    </>
  );
};
